<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import SectionHead from "./SectionHead.svelte";
  import GrowthChart from "./diagrams/GrowthChart.svelte";
  import ImagePlaceholder from "./ImagePlaceholder.svelte";

  const mk = $derived(i18n.t.market);
</script>

<section class="section market" id="market">
  <div class="container">
    <SectionHead label={mk.label} title={mk.title} lead={mk.lead} align="center" />

    <div class="feature">
      <div class="chart card reveal" use:inview>
        <h3>{mk.chart.title}</h3>
        <div class="chart-fig">
          <GrowthChart cagr={mk.chart.cagr} unit={mk.chart.unit} years={mk.chart.years} />
        </div>
        <p>{mk.chart.caption}</p>
      </div>

      <div class="place reveal" use:inview={{ delay: 120 }}>
        <ImagePlaceholder
          src="/images/market/nagoya-station-ai.png"
          alt={mk.place.alt}
          ratio="4 / 3"
          label={mk.place.alt}
        />
        <h3>{mk.place.title}</h3>
        <p>{mk.place.caption}</p>
      </div>
    </div>

    <div class="grid">
      {#each mk.stats as stat, i}
        <div class="stat reveal" use:inview={{ delay: (i % 3) * 90 }}>
          <strong>{stat.value}</strong>
          <p>{stat.label}</p>
          <span class="src">{stat.source}</span>
        </div>
      {/each}
    </div>

    <p class="note reveal" use:inview>{mk.note}</p>
  </div>
</section>

<style>
  .market {
    border-top: 1px solid var(--line);
    background:
      radial-gradient(80% 60% at 50% 0%, rgba(95, 179, 100, 0.08), transparent 60%),
      var(--paper-deep);
  }
  .feature {
    margin-top: clamp(2.5rem, 1.5rem + 3vw, 4rem);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.2rem;
    align-items: stretch;
  }
  .chart {
    padding: clamp(1.4rem, 1.1rem + 1.2vw, 2rem);
  }
  .chart h3 {
    font-size: 1.2rem;
  }
  .chart-fig {
    margin: 1.2rem 0 0.4rem;
  }
  .chart p,
  .place p {
    margin-top: 0.8rem;
    color: var(--ink-soft);
    font-size: 0.92rem;
    line-height: 1.75;
  }
  .place {
    display: flex;
    flex-direction: column;
  }
  .place h3 {
    margin-top: 1.1rem;
    font-size: 1.2rem;
  }

  .grid {
    margin-top: 1.2rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
  .stat {
    text-align: center;
    padding: 1.6rem 1rem;
    background: var(--paper-card);
    border: 1px solid var(--line);
    border-radius: var(--radius);
  }
  .stat strong {
    display: block;
    font-family: var(--font-display);
    font-weight: 600;
    font-size: clamp(2.2rem, 1.6rem + 2.4vw, 3.2rem);
    line-height: 1;
    color: var(--green-deep);
    letter-spacing: -0.01em;
  }
  .stat p {
    margin: 0.9rem auto 0;
    max-width: 26ch;
    font-size: 0.92rem;
    color: var(--ink-soft);
    line-height: 1.65;
  }
  .src {
    display: inline-block;
    margin-top: 0.8rem;
    font-family: var(--font-mono);
    font-size: 0.68rem;
    letter-spacing: 0.06em;
    color: var(--muted);
  }
  .note {
    margin: 2.2rem auto 0;
    max-width: 70ch;
    text-align: center;
    font-size: 0.78rem;
    color: var(--muted);
    line-height: 1.7;
  }

  @media (max-width: 820px) {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .feature {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 520px) {
    .grid {
      grid-template-columns: 1fr;
    }
  }
</style>
